<template>
  <div>
    <div class="troca-responsavel">
      <div>
        <legend style="font-size: 14px;">
          {{ label }}
        </legend>
      </div>
      <div
        v-if="trocaResponsavel"
        style="padding-left: 0.4rem"
      >
        <i
          v-b-tooltip.hover
          title="Para efetuar a troca geral de todas as empresas vinculadas ao responsável escolhido, basta deixar o campo empresa em branco. Também é possível realizar a troca por empresa ou seleção de empresas"
          style="font-size: 0.65rem;"
          class="question-icon"
        >
          <font-awesome-icon
            :icon="faQuestionCircle"
          />
        </i>
      </div>
    </div>
    <validation-provider
      #default="{ errors }"
      :rules="{required: require_}"
      name="Empresa"
    >
      <multiselect
        ref="empresaMultiSelect"
        v-model="value_"
        v-b-tooltip.hover
        :title="titlePopover"
        :disabled="disabled"
        :options="empresas"
        :limit="limit"
        :close-on-select="false"
        :clear-on-select="false"
        :multiple="multiple"
        :internal-search="false"
        label="razaoSocial"
        placeholder=""
        track-by="id"
        class="empresa-multiselect"
        :select-label="''"
        :deselect-label="''"
        :selected-label="''"
        :limit-text="limitText"
        @close="onTouch"
        @open="carregarEmpresas"
        @search-change="carregarEmpresasFiltradas"
        @input="enviarParaPai"
        @select="enviarParaPaiChange"
      >
        <template slot="noResult">
          <span>Nenhum resultado encontrado</span>
        </template>
        <template slot="noOptions">
          <span v-if="!empresaLoading">Nenhuma Empresa cadastrada</span>
          <span v-else-if="empresaLoading">Carregando empresas...</span>
        </template>
        <template
          slot="option"
          slot-scope="props"
        >
          <div style="display: flex;">
            <div :class="['company-identification', {'company-identification-parcial': props.option.empresaContrato}, {'company-identification-inativa': !props.option.ativo}]">
              <span>{{ props.option.cadastroFederal }}</span>
            </div>
            <div
              v-if="props.option.empresaContrato"
              :class="['company-identification', {'company-identification-parcial': props.option.empresaContrato}]"
              style="margin-left: 0.5rem;"
            >
              <span>Modo parcial</span>
            </div>
            <div
              v-if="!props.option.ativo"
              :class="['company-identification', {'company-identification-inativa': !props.option.ativo}]"
              style="margin-left: 0.5rem;"
            >
              <span>Inativo</span>
            </div>
          </div>
          <div style="padding-right: 1rem; padding-bottom: 0.25rem;">
            <i
              v-if="isOptionSelected(props.option.id, value_)"
              class="fa fa-check float-right"
            />
          </div>
          <span
            style="white-space: break-spaces; margin-left: -0.2rem;"
            :class="[{'text-danger': !props.option.ativo && !isOptionSelected(props.option.id, value_)}, {'text-parcial': props.option.empresaContrato && !isOptionSelected(props.option.id, value_)}]"
          >
            {{ props.option.razaoSocial }}
          </span>
        </template>
        <template slot="limit">
          <strong
            v-if="value_"
            id="empresasSelecionadas"
            class="multiselect__strong"
          >{{ `+ ${value_.length - limit}` }}</strong>
          <b-popover
            id="empresasPopover"
            :placement="'bottom'"
            :target="'empresasSelecionadas'"
            triggers="hover"
            custom-class="multiselect-popover"
            @show="showPopover($event)"
          >
            <div slot="title">
              <span
                class="text-center"
                style="vertical-align: sub"
              >Empresas selecionadas</span>
            </div>
            <div>
              <div
                v-for="(empresa, i) in value_"
                :key="i"
              >
                <b-row>
                  <b-col cols="12">
                    <span :class="[{'text-danger': !empresa.ativo}, {'text-parcial': empresa.empresaContrato}]">{{ `${empresa.razaoSocial} - ${empresa.cadastroFederal}` }}</span>
                    <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-popover>
        </template>
      </multiselect>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </div>
</template>

<style lang="scss">
.troca-responsavel {
  display: flex;
}

.question-icon {
  font-size: 0.65;
  align-self: center;
  display: block;
}

.company-identification {
  & span {
    font-size: 0.65rem;
    color: var(--primary);
    font-weight: 700;
    background-color: transparent;
    border: 1px solid var(--primary) !important;
    border-radius: 2px;
    padding: 0.1rem 0.2rem;
  }
}

.company-identification-inativa {
  & span {
    font-size: 0.65rem;
    color: var(--danger);
    font-weight: 700;
    background-color: transparent;
    border: 1px solid var(--danger) !important;
    border-radius: 2px;
    padding: 0.1rem 0.2rem;
  }
}

.company-identification-parcial {
  & span {
    font-size: 0.65rem;
    color: #ff8d00;
    font-weight: 700;
    background-color: transparent;
    border: 1px solid #ff8d00 !important;
    border-radius: 2px;
    padding: 0.1rem 0.2rem;
  }
}

.text-parcial {
  color: #ff8d00;
}

.badge-dados {
  border-radius: 2px;
  font-size: 0.65rem;
  font-weight: 700;
  border-radius: 2px;
  padding: 0.1rem 0.2rem;
}

.empresa-multiselect {
  background: none;
  border-radius: 0.357rem;
  & .multiselect__element .company-identification {
    &.company-identification--selected span,
    &.company-identification--highlight span {
      text-overflow: ellipsis !important;
      overflow: hidden !important;
      padding-right: 6.3em !important;
    }
  }

  & .multiselect__content {
    display: block !important;
  }

  & .multiselect__element {
    font-size: 0.9rem;
  }

  & .multiselect__strong {
    right: 26px !important;
  }

  & .multiselect__tags {
    padding-right: 0px !important;
    max-height: auto !important;
  }

  & .multiselect__tag {
    white-space: nowrap !important;
    overflow: hidden !important;
    max-width: calc(23em - 25px);
    text-overflow: ellipsis !important;
    background: var(--primary) !important;
    border-radius: 3px !important;
    span {
      font-size: 0.9rem;
    }
  }

  & .multiselect__option {
    & svg {
      display: none;
    }
  }

  & .multiselect__option--selected {
    background: var(--primary) !important;
    color: #ffffff !important;
    font-weight: normal;
    & .company-identification span {
      color: #ffffff !important;
      background-color: transparent;
      border: 1px solid #ffffff !important;
    }
    & svg {
      display: inline;
    }
  }

  & .multiselect__option--highlight {
    background: rgba(var(--primary-rgb), 0.1);
    color: var(--primary);
  }

  & .multiselect__strong {
    color: var(--primary);
    cursor: pointer;
  }

  & .multiselect__tag-icon::after {
    color: #78682ad1;
    font-size: 1.7rem;
  }

  & .multiselect__tag-icon:hover {
    background: none;
  }
}

.multiselect-popover .popover-body {
  max-height: calc(40vh - 30px);
  overflow-y: auto;
  overflow-x: hidden;
  white-space: pre-wrap;

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #bfbfbf;
  }
}
</style>

<script>
/* eslint-disable no-underscore-dangle */
import {
  required,
} from '@validations'
import { ValidationProvider } from 'vee-validate'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comuns/empresa/shared/services/api'

export default {
  name: 'EmpresaMultiselect',
  components: {
    Multiselect,
    ValidationProvider,
    FontAwesomeIcon,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    require: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [Object, Array],
      default: () => { },
    },
    filtroAdicional: {
      type: Function,
      default: () => null,
    },
    label: {
      type: String,
      default: () => 'Empresa',
    },
    titlePopover: {
      type: String,
      default: '',
    },
    multiselect: {
      type: Boolean,
      default: false,
    },
    trocaResponsavel: {
      type: Boolean,
      default: false,
    },
    painelProposta: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      faQuestionCircle,
      valueAttr: null,
      foiAcessado: false,
      empresas: [],
      primeiroAcesso: true,
      filtros: [
        {
          colunas: ['nome', 'registrofederal', 'integracao'],
          valor: null,
        },
      ],
      empresasCarregadas: [],
      limit: 3,
      empresaLoading: false,
    }
  },
  computed: {
    value_: {
      get() {
        return this.valueAttr ? this.valueAttr : this.value
      },
      set(value) {
        this.valueAttr = value
      },
    },
    isInvalid() {
      return this.invalid && this.foiAcessado
    },
    require_: {
      get() {
        return this.require
      },
    },
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        this.value_ = val
      }
    },
  },
  mounted() {
    if (this.trocaResponsavel) {
      this.limit = 2
    } else if (this.painelProposta) {
      this.limit = 1
    } else if (this.$refs.empresaMultiSelect) {
      const element = this.$refs.empresaMultiSelect.$el.offsetWidth
      this.limit = Math.trunc(element / 180)
    }
  },
  methods: {
    showPopover(e) {
      const el = document.getElementsByClassName('multiselect empresa-multiselect multiselect--active')
      if (el.length === 1) {
        e.preventDefault()
      }
    },
    limitText(count) {
      return `+${count}`
    },
    carregarEmpresas() {
      const el = document.getElementById('empresasPopover')
      if (el) {
        this.$refs.empresaMultiSelect.isOpen = false
      } else if (!el) {
        if (this.primeiroAcesso) {
          this.empresaLoading = true
          api.getEmpresasResumidas(this.filtros)
            .then(payload => {
              this.empresasCarregadas = payload.data
              this.setItensCarregados(payload.data)
              this.primeiroAcesso = false
              this.empresaLoading = false
              this.$refs.empresaMultiSelect.isOpen = true
            })
            .catch(err => {
              this.empresaLoading = false
              this.$errorFormated(err.response)
              throw err
            })
        } else {
          this.$refs.empresaMultiSelect.isOpen = true
        }
      }
    },
    carregarEmpresasFiltradas(value) {
      this.filtros[0].valor = value
      this.empresaLoading = true
      api.getEmpresasResumidas(this.filtros)
        .then(payload => {
          this.setItensCarregados(payload.data)
          this.empresaLoading = false
        })
        .catch(err => {
          this.$errorFormated(err.response)
          throw err
        })
    },
    propagarParaFilho() {
      this.$refs.empresaSelect.focus()
    },
    enviarParaPai() {
      this.$emit('select', !this.value_ ? null : this.value_)
      this.$emit('input', !this.value_ ? null : this.value_)
    },
    enviarParaPaiChange() {
      this.$emit('change', !this.value_ ? null : this.value_)
    },
    onTouch() {
      this.foiAcessado = true
    },
    limpar() {
      this.value_ = []
    },
    setItensCarregados(itensCarregados) {
      const itensFiltroAdicional = this.filtroAdicional(itensCarregados)
      this.empresas = itensFiltroAdicional !== null ? itensFiltroAdicional : itensCarregados
    },
    isOptionSelected(currentOption, options) {
      if (options) {
        return options.filter(item => item.id === currentOption).length > 0
      }
      return false
    },
  },
}
</script>
